import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Users, Shield, Clock, ArrowLeft } from 'lucide-react';

export default function HomePage() {
  const features = [
    {
      icon: BookOpen,
      title: 'كورسات متنوعة',
      description: 'مجموعة واسعة من الكورسات في مختلف التخصصات'
    },
    {
      icon: Shield,
      title: 'محتوى محمي',
      description: 'فيديوهات عالية الجودة محمية من التحميل غير المصرح'
    },
    {
      icon: Clock,
      title: 'مرونة في التعلم',
      description: 'تعلم في الوقت الذي يناسبك مع إمكانية الوصول على مدار الساعة'
    },
    {
      icon: Users,
      title: 'نظام متقدم',
      description: 'إدارة الاشتراكات بسهولة عبر السيريال نمبر'
    }
  ];

  return (
    <div className="min-h-[calc(100vh-4rem)]">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-amber-50 to-stone-100 py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8">
            <div className="w-20 h-20 mx-auto mb-6 bg-white/70 backdrop-blur rounded-3xl shadow-lg flex items-center justify-center border border-amber-200">
              <img
                src="/assets/logo.png"
                alt="شعار Feda Creativity أونلاين"
                className="w-16 h-16 object-contain"
                loading="lazy"
                width={64}
                height={64}
              />
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-stone-900 mb-6 leading-tight">
              Feda Creativity
              <span className="block text-amber-600">أونلاين</span>
            </h1>
            <p className="text-xl text-stone-600 mb-8 max-w-2xl mx-auto leading-relaxed">
              تعلم مهارات جديدة واحترف تخصصك من خلال كورسات عالية الجودة مع نظام حماية متطور للمحتوى
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/courses"
              className="bg-amber-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-amber-700 transition-colors flex items-center space-x-2 rtl:space-x-reverse shadow-lg"
            >
              <span>استكشف الكورسات</span>
              <ArrowLeft className="w-5 h-5 rtl:rotate-180" />
            </Link>
            
            <Link
              to="/profile"
              className="bg-white text-stone-700 px-8 py-4 rounded-lg font-semibold hover:bg-stone-50 transition-colors shadow-lg border border-stone-200"
            >
              الملف الشخصي
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4">
              لماذا تختار منصتنا؟
            </h2>
            <p className="text-xl text-stone-600 max-w-2xl mx-auto">
              نقدم تجربة تعليمية متميزة مع أحدث التقنيات لضمان حماية المحتوى وسهولة الاستخدام
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <div key={index} className="bg-white p-8 rounded-2xl shadow-lg border border-stone-100 hover:shadow-xl transition-shadow">
                  <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center mb-6">
                    <IconComponent className="w-6 h-6 text-amber-600" />
                  </div>
                  <h3 className="text-xl font-bold text-stone-900 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-stone-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section className="bg-stone-100 py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4">
            كيف يعمل النظام؟
          </h2>
          <p className="text-xl text-stone-600 mb-12">
            خطوات بسيطة للبدء في التعلم
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-amber-600 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-xl font-bold">
                1
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-3">
                تواصل معنا للاشتراك
              </h3>
              <p className="text-stone-600 mb-4">
                احصل على تفاصيل الاشتراك والسيريال المناسب للكورس عبر قنواتنا الرسمية
              </p>
              <ul className="text-stone-600 space-y-2">
                <li>انستكرام: @feda_creativity</li>
                <li>اتصال و واتساب: 07703177889</li>
                <li>ايميل:     info@fedacreativity.com</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-amber-600 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-xl font-bold">
                2
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-3">
                احصل على السيريال نمبر
              </h3>
              <p className="text-stone-600">
                سيصلك رمز تفعيل فريد للكورس الذي تريد الاشتراك به بعد التواصل معنا
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-amber-600 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-xl font-bold">
                3
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-3">
                فعل الاشتراك
              </h3>
              <p className="text-stone-600">
                أدخل السيريال نمبر في ملفك الشخصي لتفعيل الاشتراك لمدة شهر
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-amber-600 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-xl font-bold">
                4
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-3">
                ابدأ التعلم
              </h3>
              <p className="text-stone-600">
                شاهد جميع مقاطع الفيديو في الكورس واستفد من المحتوى المتميز
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-gradient-to-r from-amber-600 to-amber-700 rounded-3xl p-12 text-white">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              ابدأ رحلتك التعليمية اليوم
            </h2>
            <p className="text-xl opacity-90 mb-8">
              انضم إلى آلاف الطلاب الذين يتعلمون مهارات جديدة كل يوم
            </p>
            <Link
              to="/courses"
              className="bg-white text-amber-600 px-8 py-4 rounded-lg font-semibold hover:bg-stone-50 transition-colors inline-flex items-center space-x-2 rtl:space-x-reverse shadow-lg"
            >
              <span>تصفح الكورسات المتاحة</span>
              <ArrowLeft className="w-5 h-5 rtl:rotate-180" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}